const philosophy = () => {
  const items = document.querySelectorAll('.p-philosophy__sbs__list__item');
  if(items.length > 0) {
    const item1 = document.querySelector('#js-list-item1');
    const item2 = document.querySelector('#js-list-item2');
    const item3 = document.querySelector('#js-list-item3');

    const path1 = document.querySelector('#js-list-path1');
    const path2 = document.querySelector('#js-list-path2');
    const path3 = document.querySelector('#js-list-path3');

    let lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;

    const observerOptions = {
        root: null,
        rootMargin: '0px',
        threshold: 0.2
    };

    const removeActiveClass = () => {
        path1.classList.remove('is-active');
        path2.classList.remove('is-active');
        path3.classList.remove('is-active');
    };

    const addActiveClassByEntry = (entry) => {
        if (entry.isIntersecting && entry.target.id === 'js-list-item1') {
            removeActiveClass();
            path1.classList.add('is-active');
        } else if (entry.isIntersecting && entry.target.id === 'js-list-item2') {
            removeActiveClass();
            path2.classList.add('is-active');
        } else if (entry.isIntersecting && entry.target.id === 'js-list-item3') {
            removeActiveClass();
            path3.classList.add('is-active');
        }
    };

    const observer = new IntersectionObserver((entries, observer) => {
        const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const scrollDown = currentScrollTop > lastScrollTop;
        lastScrollTop = currentScrollTop;

        entries.sort((a, b) => {
            // 要素の表示順を保証するために、DOM ツリー上の出現順でソート
            if (a.target.compareDocumentPosition(b.target) & Node.DOCUMENT_POSITION_PRECEDING) {
                return -1;
            } else {
                return 1;
            }
        });

        entries.forEach(entry => {
            if (entry.isIntersecting) {
                removeActiveClass();
            }
        });

        if (scrollDown) {
            entries.sort((a, b) => {
                return a.target.compareDocumentPosition(b.target) & Node.DOCUMENT_POSITION_FOLLOWING ? 1 : -1;
            });
            entries.forEach(entry => addActiveClassByEntry(entry));
        } else {
            entries.sort((a, b) => {
                return a.target.compareDocumentPosition(b.target) & Node.DOCUMENT_POSITION_PRECEDING ? 1 : -1;
            });
            entries.forEach(entry => addActiveClassByEntry(entry));
        }

        if ((window.innerHeight + window.pageYOffset) >= document.body.offsetHeight) {
            // 最下部に達した場合の処理
            removeActiveClass();
            path3.classList.add('is-active');
        }
    }, observerOptions);

    observer.observe(item1);
    observer.observe(item2);
    observer.observe(item3);
  }
};
